import { FC } from "react";
import { Stack } from "@mui/material";
import { useAppSelector } from "@/store/hooks";
import { normalizedCostWidgetNotFoundSelector } from "@/store/dashboards/selectors/widgets/normalized-cost-widget/widget-view/normalizedCostWidgetNotFoundSelector";
import { normalizedCostWidgetByIdSelector } from "@/store/dashboards/selectors/widgets/normalized-cost-widget/widget-view/normalizedCostWidgetByIdSelector";
import { DashboardNotFoundWidget } from "@/components/pages/dashboard/components/widgets/common/DashboardNotFoundWidget";
import { resourceExplorerViewNameByViewIdSelector } from "@/store/resource-explorer/selectors/all-resource-explorers/resourceExplorerViewNameByViewIdSelector";
import { DashboardEmptyWidgetState } from "@/components/pages/dashboard/components/widgets/common/DashboardEmptyWidgetState";
import { NormalizedCostWidgetContentAggregations } from "@/components/pages/dashboard/components/widgets/normalized-cost-widget/components/NormalizedCostWidgetContentAggregations";
import { NormalizedCostWidgetContentTableView } from "@/components/pages/dashboard/components/widgets/normalized-cost-widget/components/table/NormalizedCostWidgetContentTableView";

import { NormalizedCostWidgetContentChartView } from "@/components/pages/dashboard/components/widgets/normalized-cost-widget/components/NormalizedCostWidgetContentChartView";

interface NormalizedCostWidgetContentProps {
  widgetId: string;
}

export const NormalizedCostWidgetContent: FC<
  NormalizedCostWidgetContentProps
> = ({ widgetId }) => {
  const widgetDataNotFound = useAppSelector((state) =>
    normalizedCostWidgetNotFoundSelector(state, widgetId),
  );
  const widget = useAppSelector((state) =>
    normalizedCostWidgetByIdSelector(state, widgetId),
  );
  const viewName = useAppSelector((state) =>
    resourceExplorerViewNameByViewIdSelector(state, widget?.view_id),
  );

  const chartType = widget?.visualization?.chart_type ?? "line";

  if (widgetDataNotFound) {
    return (
      <DashboardNotFoundWidget name={viewName ?? ""} label="billing report" />
    );
  }

  if (!widget) {
    return <DashboardEmptyWidgetState infoCards={infoCards} />;
  }

  return (
    <Stack flex={1} p={2}>
      <NormalizedCostWidgetContentAggregations widgetId={widgetId} />

      {chartType === "table" && (
        <NormalizedCostWidgetContentTableView widgetId={widgetId} />
      )}

      {!["numeral", "table"].includes(chartType) && (
        <NormalizedCostWidgetContentChartView widgetId={widgetId} />
      )}
    </Stack>
  );
};

const infoCards = [
  {
    value: "-",
    title: "Actual Total Cost",
  },
  {
    value: "-",
    title: "Avg Normalized Monthly Cost",
  },
];
